import React, { useState, useEffect } from 'react';
import Modal from './Modal';

function ErrorReworkModal({
  isOpen,
  onClose,
  onSubmit,
  title = "Please enter reason: ",
  labels,
  stageList
}) {
  // Initialize state as an object with keys from labels array
  const [userInputs, setUserInputs] = useState("");
  const [errorStage, setErrorStage] = useState("");
  
  // Function to handle form submission
  const handleSubmit = () => {
      onSubmit(userInputs, errorStage);
      setUserInputs("");
      setErrorStage("");
  };
  
  // Check if submit button should be disabled (if any field is empty)
  const isSubmitDisabled = userInputs === null || userInputs === "";

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-4">
        <h4 className="mb-3" style={{ whiteSpace: 'pre-line' }}>{title}</h4>

        <div className="mb-3">
        <label htmlFor="stageList" className="form-label">Select Error Stage:</label>
        <select
        id="stageList"
        className='form-select'
        value={errorStage||''}
        onChange={(e) => {
            e.preventDefault();
            setErrorStage(e.target.value)
        }}
        >
            <option value='' disabled>-- Select --</option>
            {stageList?.map((type) => (
                !type.includes('All') &&
                <option key={type} value={type}>
                {type}
                </option>
            ))}
        </select>
        </div>
        
        <div className="mb-3">
        <label htmlFor="datePicker" className="form-label">{labels} Reason:</label>
        <textarea
            name="reason"
            className="form-control"
            id={`datePicker`}
            value={userInputs}
            onChange={(e) => setUserInputs(e.target.value)}
        />
        </div>
        
        <div className="d-flex justify-content-end">
          <button 
            className="btn btn-secondary me-2" 
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="btn btn-primary" 
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
          >
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ErrorReworkModal;